import React from 'react';
import cx from 'classnames';
import Warning from './Warning';

export default class Error extends React.Component {
	render() {
		return (
			<div className={cx("content", this.props.is_center?"content-error-link":"")}>
				<Warning title={this.props.title} message={this.props.message} redirectTo={this.props.redirectTo} button_text={this.props.button_text} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/Error.js